import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class QuestService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getQuestDates(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Quest/GetQuestDates', messageService);
    }

    public getQuests(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Quest/GetQuests', data, messageService);
    }

    public export(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/Quest/Export', data, messageService);
    }

    public finishRaffle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Quest/FinishRaffle', data, messageService);
    }

    public isTicketDraw(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Quest/IsTicketDraw', data, messageService);
    }

    public isWinnerChosen(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Quest/IsWinnerChosen', data, messageService);
    }

    public getQuestReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressQuest/GetQuestReport', data, messageService);
    }

    public exportQuestReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressQuest/ExportQuestReport', data, messageService);
    }
}
